<template>
  <div class="name" ref="my_box_a">
    <div class="accord"></div>
    <div class="search-container">
      <div class="project-search-bar">
        <span class="mic" @click.prevent="voiceRecog"
          ><i class="bi bi-mic"></i
        ></span>
        <input
          type="text"
          v-model="input"
          :placeholder="placeholderValue"
          @input="searchProjectName()"
        />
        <div class="search-icon-container">
          <img
            v-if="!isSearching"
            src="../assets/search.svg"
            class="search-icon"
            alt="search icon"
          />
          <img
            v-else
            src="../assets/close.svg"
            class="search-icon"
            @click="nonSearchingState"
          />
        </div>
      </div>
    </div>
    <div class="main-container-wrapper overflow-scroll">
      <div v-for="(project, i) in allProjectDetails" :key="i">
        <project-name-card
          :hostedLink="project.link"
          :projectName="project.name"
          :activeId="activeId"
          :index="i"
          :isSearching="isSearching"
          @changeActive="changeActive"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProjectNameCard from "./ProjectNameCard.vue";
import projectDetails from "../assets/data";

export default {
  data() {
    return {
      allProjectDetails: [],
      windowHeight: 0,
      searchProjects: [],
      activeId: null,
      input: "",
      isSearching: false,
      placeholderValue: "Search Projects...",
      isMobile: false,
      posBoxA: 0,
      searchProjectName: () => {
        this.allProjectDetails = [...this.searchProjects];
        this.isSearching = true;
        const searchTerm = this.allProjectDetails.filter(ele => {
          return ele.name.toLowerCase().includes(this.input.toLowerCase());
        });
        this.allProjectDetails = searchTerm;
      }
    };
  },

  name: "AllProjectsNames",
  components: { ProjectNameCard },
  mounted() {
    this.allProjectDetails = projectDetails.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      } else if (a.name > b.name) {
        return 1;
      } else {
        return 0;
      }
    });
    this.searchProjects = [...this.allProjectDetails];
    if (this.$route.query.projectName !== "?") {
      this.getAllProjectsName();
    }
    this.checkMobileView();
    this.calcPosOfBox();
    window.addEventListener("resize", this.checkMobileView);
  },
  methods: {
    checkMobileView() {
      this.isMobile = window.innerWidth <= 779;
    },
    getAllProjectsName() {
      this.activeId = this.allProjectDetails[0].name;
      this.$emit("displayNewProject", {
        projectLink: this.allProjectDetails[0]
      });
      if (this.$route.query.projectName !== this.allProjectDetails[0].name) {
        this.$router.replace({
          query: {
            projectName: this.allProjectDetails[0].name
          }
        });
      }
    },
    changeActive({ id }) {
      this.windowHeight = window.innerHeight;
      this.activeId = id;
      if (this.$route.query.projectName !== id) {
        this.$router.replace({
          query: { projectName: id.split(" ").join("") }
        });
      }
      const projectLink = this.allProjectDetails.filter(
        project => id === project.name
      );
      if (this.isMobile) {
        this.calcPosOfBox();
      }
      this.$emit("displayNewProject", { projectLink: projectLink[0] });
    },
    nonSearchingState() {
      this.isSearching = false;
      this.allProjectDetails = projectDetails;
      this.input = "";
      this.placeholderValue = "Search Projects...";
      this.getAllProjectsName();
    },
    calcPosOfBox() {
      if (!this.isMobile) return;
      console.log(
        this.$refs["my_box_a"].getBoundingClientRect().top,
        "+++",
        this.windowHeight
      );
      this.posBoxA =
        (this.$refs["my_box_a"].getBoundingClientRect().top > 0
          ? this.$refs["my_box_a"].getBoundingClientRect().top
          : 0) +
        this.windowHeight -
        100;
      window.scrollTo({
        top: this.posBoxA
      });
    },
    voiceRecog() {
      let recognization = new webkitSpeechRecognition();
      setTimeout(() => {
        if (this.input === "") {
          this.nonSearchingState();
          alert(
            "Turning off Speech recognition,as nothing spoken was detected"
          );
          recognization.onspeechend = () => {
            recognization.stop();
          };
        }
      }, 5000);
      recognization.lang = "en-US";
      recognization.onstart = () => {
        this.placeholderValue = "Listening...";
      };
      recognization.onresult = e => {
        var transcript = e.results[0][0].transcript;
        this.input = transcript;
        this.searchProjectName();
      };
      recognization.onnomatch = () => {
        alert("I didn't recognize the speech,Please try again.");
      };
      recognization.start();
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobileView); // Clean up the event listener
  }
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0.4rem;
}
::-webkit-scrollbar-track {
  background: #888;
}

::-webkit-scrollbar-thumb {
  background: #3a80e9;
  border-radius: 1rem;
}
.accord {
  margin: 10px 10px;
  padding: 10px;
}
article {
  margin-top: 10px;
  width: 90%;
}
.main-container-wrapper {
  height: 36rem;
  overflow-x: hidden !important;
}
.search-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px;
  height: 36px;
  margin: 16px 0 40px 0;
}
.project-search-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  border-bottom: 2px solid black;
}
.project-search-bar .plot-select-search-bar {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #b9c1bd;
  background: #fff;
  box-shadow: 0px 1px 38px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.search-container .project-search-bar .plot-select-search-bar:focus {
  color: #212121;
}
.search-container .project-search-bar .search-icon-container {
  position: absolute;
  top: 30px;
  right: 22px;
}
.search-container .project-search-bar .search-icon-container img {
  height: 16px;
}
input {
  display: block;
  width: 95%;
  margin: 20px auto;
  padding: 10px 30px;
  background: white no-repeat 15px center;
  background-size: 15px 15px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
}
.mic {
  position: absolute;
  left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/AllProjectNames.vue